var super_collection = {
  init: function () {
    $("body").on("click", ".facets__summary", function () {
      var filterWrap = $(this).closest(".js-filter");

      if ($(window).width() < 768) {
        $(this).next(".facet-filter-list").slideToggle();
      } else {
        $(".facet-filter-detail").removeAttr("open");
        $(this).closest(".facet-filter-detail").attr("open", true);
      }
    });

    $("body").on("click", ".facets-wrap-close", function (e) {
      e.preventDefault();
      $(this).closest(".facet-filter-detail").removeAttr("open");
    });

    $("body").on("click", ".facets__form-close", function (e) {
      e.preventDefault();
      $(this)
        .closest(".facets-container")
        .find(".facets")
        .removeClass("active");
    });

    $(document).mouseup(function (e) {
      var container = $(".facet-filter-list");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".facet-filter-detail").removeAttr("open");
      }
    });

    $(".c__filters-button").on("click", function () {
      $(this).closest(".facets-container").find(".facets").addClass("active");
    });

    $("body").on("click", ".js-facets-trigger", function () {
      var facetsFrom = document.querySelector("#FacetFiltersForm");
      var formData = new FormData(facetsFrom);
      var searchParams = new URLSearchParams(formData).toString();
      const url = `${window.location.pathname}?${searchParams}`;
      var collectionWrap = $(this).closest("#CollectionProductGrid");
      var colGridWrap = collectionWrap.find("#main-collection-product-grid");
      var paginationWrap = collectionWrap.find(".pagination-wrapper");

      collectionWrap.addClass("loading");
console.log(url);
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          const parsedHTML = new DOMParser().parseFromString(html, "text/html");
          var colGrid = $(parsedHTML)
            .find("#main-collection-product-grid")
            .html();
          var factsFormContent = $(parsedHTML).find("#FacetFiltersForm").html();
          var paginationContent = $(parsedHTML)
            .find(".pagination-wrapper")
            .html();

          colGridWrap.empty().append(colGrid);
          $(facetsFrom).empty().append(factsFormContent);
          paginationWrap.empty().append(paginationContent);
          collectionWrap.removeClass("loading");
        });
      $(".facet-filter-detail").removeAttr("open");
      $(this)
        .closest(".facets-container")
        .find(".facets")
        .removeClass("active");
    });

    $("body").on("click", "#AjaxinatePagination a", function (e) {
      e.preventDefault();
      var url = $(this).attr("href");
      var facetsFrom = document.querySelector("#FacetFiltersForm");
      var formData = new FormData(facetsFrom);
      var searchParams = new URLSearchParams(formData).toString();
      var collectionWrap = $(this).closest("#CollectionProductGrid");
      var colGridWrap = collectionWrap.find("#main-collection-product-grid");
      var paginationWrap = collectionWrap.find(".pagination-wrapper");

      collectionWrap.addClass("loading");

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          const parsedHTML = new DOMParser().parseFromString(html, "text/html");
          var colGrid = $(parsedHTML)
            .find("#main-collection-product-grid")
            .html();
          var factsFormContent = $(parsedHTML).find("#FacetFiltersForm").html();
          var paginationContent = $(parsedHTML)
            .find(".pagination-wrapper")
            .html();

          colGridWrap.append(colGrid);
          $(facetsFrom).empty().append(factsFormContent);
          paginationWrap.empty().append(paginationContent);
          collectionWrap.removeClass("loading");
        });
      $(".facet-filter-detail").removeAttr("open");
      $(this)
        .closest(".facets-container")
        .find(".facets")
        .removeClass("active");
    });
  },
};

$(document).ready(function () {
  super_collection.init();

  $("body").on("click", ".js-filter-ul a", function (e) {
    e.preventDefault();

    var url = $(this).attr("href");

    $(this).closest(".js-filter-ul").find("li").removeClass("active");
    $(this).closest("li").addClass("active");
    collection_filter(url);
  });

  $("#SortBy").on("change", function () {
    var selected_sort = $(this).val();
    var url = window.location.pathname + "?sort_by=" + selected_sort;

    collection_filter(url);
  });

  function collection_filter(url) {
    var countContainer = $("#CollectionProductGrid");

    countContainer.find(".collection").addClass("loading");
    window.history.pushState({}, "", url);

    $.ajax({
      type: "get",
      url: url,
      success: function (data) {
        var html = new DOMParser().parseFromString(data, "text/html");
        var collectionList = $(html)
          .find("#main-collection-product-grid")
          .html();

        $("#main-collection-product-grid").empty().append(collectionList);
        countContainer.find(".collection").removeClass("loading");
      },
      error: function (data) {
        console.log(data);
      },
    });
  }
});
